import React, { Component } from 'react';
import { Form, Spin } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import {
  Container,
  PrimaryButtonV2,
  formLayout,
  formValidateMessages,
  FormWrapper,
  SpaceBetween,
  SecondaryButton,
  AddFormItemLabel,
  AddSaveHint,
  addMetaData,
} from 'utils';
import RichText from './RichText';
import { ProjectsActions } from 'redux/actions';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

const FormItem = Form.Item;

class ProjectDescription extends Component {
  formRef = React.createRef();

  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired
  };

  state = {
    initialValues: {
      projekt: '',
      zielgruppe: '',
      unterstützen: '',
      finanzierung: '',
      hinter: '',
    },
  };

  onFinish = (values) => {
    const {
      updateDraft,
      project,
      projectId,
      currentStep,
      setCanMove,
      showModal,
      selectedStep,
      setSubmitFromModal,
      editProject,
    } = this.props;
    const isTicketable = Boolean(project?.fundingTarget?.is_ticketable);

    const { projekt, zielgruppe, unterstützen, finanzierung, hinter } = values;
    let projectDescription = {
      faq: [projekt?? "", zielgruppe ?? "", unterstützen ?? "", finanzierung?? "", hinter?? ""],
    };

    const metaData = addMetaData(project);

    if (metaData) {
      projectDescription = { ...projectDescription, meta_data: metaData };
    }

    if (showModal) {
      updateDraft(projectId, projectDescription, selectedStep - 1);
      setSubmitFromModal(false);
    } else {
      updateDraft(projectId, projectDescription, currentStep);
    }

    setCanMove(true);
    if (editProject) this.props.handleSteps(isTicketable ? 19 : 4);
    else this.props.handleSteps(6);
  };

  getContent = (content, name) => {
    this.formRef.current.setFieldsValue({ [name]: content });
  };

  onReturn = () => {
    if (this.props.editProject) this.props.handleExitEditForm();
    else this.props.handleSteps(4);
  };

  componentDidMount() {
    console.log(this.props, 'editProject');

  }

  render() {
    const { project, loading, setCanMove, projectId, editProject } = this.props;

    const isTicketable = project?.fundingTarget?.is_ticketable;

    const validationMessages = {
      projekt: isTicketable
        ? 'Bitte beschreibe den Zweck der Veranstaltung.'
        : 'Bitte beschreibe, was du mit diesem Projekt umsetzen möchtest.',

      zielgruppe: isTicketable
        ? 'Bitte beschreibe die Ziele und die Zielgruppe.'
        : 'Bitte beschreibe, wen oder was dein Projekt unterstützt und welche Wirkung erreicht werden soll.',

      unterstützen:
        'Bitte beschreibe, wofür die Unterstützungen verwendet werden.',

      finanzierung:
        'Bitte beschreibe, wie du für Transparenz und einen verantwortungsvollen Umgang mit den Unterstützungen sorgst.',

      hinter: isTicketable
        ? 'Bitte beschreibe, wer die Veranstaltung organisiert.'
        : 'Bitte beschreibe, wer hinter dem Projekt steht.',
    };

    return (
      <Container className="inside-form-container">
        <Spin spinning={loading}>
          <QuestionsMainTitle>Zusätzliche Angaben</QuestionsMainTitle>
          <QuestionsTitle>
            Nutze diese Felder, um die wichtigsten Informationen zu deinem
            Projekt verständlich darzustellen. Bitte kompakt bleiben, damit
            Unterstützer schnell einen guten Überblick erhalten.
          </QuestionsTitle>
          <QuestionsSubTitle>
            Unsere Erfahrung: Klare und gut erklärte Informationen erhöhen das
            Vertrauen und damit die Unterstützung.
          </QuestionsSubTitle>
          {!loading && (
            <Form
              ref={this.formRef}
              {...formLayout}
              name="project-details"
              onFinish={this.onFinish}
              onChange={() => setCanMove(false)}
              validateMessages={formValidateMessages}
              initialValues={
                projectId
                  ? project
                    ? pickBy(project.projectDescription, identity)
                    : {}
                  : ''
              }
            >
              <div>
                <FormWrapper>
                  <>
                    <QuestionsInfo>
                      {project?.fundingTarget?.is_ticketable
                        ? 'Was ist der Zweck der Veranstaltung?'
                        : 'Was möchtest du mit diesem Projekt umsetzen?'}
                    </QuestionsInfo>
                    <FormItem
                      name={'projekt'}
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            validationMessages.projekt
                        },
                      ]}
                    >
                      <RichText
                        name="projekt"
                        getContent={this.getContent}
                        placeholder={
                          !project?.fundingTarget?.is_ticketable
                            ? 'Beschreibe die geplante Maßnahme möglichst konkret. Was soll mit den Unterstützungen erreicht werden und warum wird die Hilfe benötigt?'
                            : 'Antwort eingeben...'
                        }
                      />
                    </FormItem>
                    <QuestionsInfo>
                      {!project?.fundingTarget?.is_ticketable
                        ? 'Wen oder was unterstützt dein Projekt – und welche Wirkung soll damit erreicht werden?'
                        : 'Was sind die Ziele und wer ist die Zielgruppe?'}
                    </QuestionsInfo>
                    <FormItem
                      name={'zielgruppe'}
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            validationMessages.zielgruppe
                        },
                      ]}
                    >
                      <RichText
                        name="zielgruppe"
                        getContent={this.getContent}
                        placeholder={
                          !project?.fundingTarget.is_ticketable
                            ? "Beschreibe die Zielgruppe des Projekts und erläutere, wie sich ihre Situation durch die Unterstützung verbessern soll. Woran erkennt man, dass das Projekt erfolgreich war? Nenne möglichst konkrete Ziele oder Ergebnisse. Beispiele: 100 Familien mit Lebensmitteln versorgen, 500 Qur'an-Exemplare verteilen, einen Brunnen bauen oder eine Moschee renovieren."
                            : 'Antwort eingeben...'
                        }
                      />
                    </FormItem>
                    {!project?.fundingTarget?.is_ticketable && (
                      <>
                        <QuestionsInfo>
                          Wofür werden die Unterstützungen verwendet?
                        </QuestionsInfo>
                        <FormItem
                          name={'unterstützen'}
                          required={false}
                          rules={[
                            {
                              required: true,
                              message:
                               validationMessages.unterstützen
                            },
                          ]}
                        >
                          <RichText
                            name="unterstützen"
                            getContent={this.getContent}
                            placeholder="Liste die wichtigsten Ausgaben auf, die durch die Unterstützungen finanziert werden sollen. Beispiele: Materialien, Baukosten, Miete, Lebensmittel, Transport, Bildungskosten, medizinische Versorgung oder technische Ausstattung."
                          />
                        </FormItem>
                      </>
                    )}
                    {!project?.fundingTarget?.is_ticketable && (
                      <>
                        <QuestionsInfo>
                          Wie sorgst du für Transparenz und einen
                          verantwortungsvollen Umgang mit den Unterstützungen?
                        </QuestionsInfo>
                        <FormItem
                          name={'finanzierung'}
                          required={false}
                          rules={[
                            {
                              required: true,
                              message:
                                validationMessages.finanzierung
                            },
                          ]}
                        >
                          <RichText
                            name="finanzierung"
                            getContent={this.getContent}
                            placeholder="Beschreibe, wie du Unterstützer über die Verwendung der Unterstützungen und den Fortschritt des Projekts informierst – z. B. durch Belege, Fotos, Berichte oder regelmäßige Updates. Dafür kannst du auch die Update-Funktion auf commonsplace nutzen."
                          />
                        </FormItem>
                      </>
                    )}
                    <QuestionsInfo>
                      {project?.fundingTarget?.is_ticketable
                        ? 'Wer sind die Organisatoren der Veranstaltung?'
                        : 'Wer steckt hinter dem Projekt?'}
                    </QuestionsInfo>
                    <FormItem
                      name={'hinter'}
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            validationMessages.hinter
                        },
                      ]}
                      validateTrigger="onBlur"
                    >
                      <RichText
                        name="hinter"
                        getContent={this.getContent}
                        placeholder={
                          !project?.fundingTarget?.is_ticketable
                            ? 'Stelle die verantwortlichen Personen, die Organisation oder die Initiative kurz vor. Erzähle, wie das Projekt entstanden ist, welche Erfahrungen ihr mitbringt und warum euch das Anliegen am Herzen liegt.'
                            : 'Antwort eingeben...'
                        }
                      />
                    </FormItem>
                  </>
                </FormWrapper>
              </div>

              {editProject && <AddSaveHint />}

              <FormItem>
                <SpaceBetween>
                  <SecondaryButton
                    type="button"
                    minWidth="120px"
                    onClick={this.onReturn}
                  >
                    {editProject ? (
                      <p>Zurück zur Projektübersicht</p>
                    ) : (
                      <>
                        <ArrowLeftOutlined />
                        <p>Zurück</p>
                      </>
                    )}
                  </SecondaryButton>

                  <PrimaryButtonV2
                    type="primary"
                    htmltype="submit"
                    minWidth="120px"
                    id="submit-button"
                  >
                    {editProject ? (
                      <p>Speichern*</p>
                    ) : (
                      <>
                        <p>Weiter</p>
                        <ArrowRightOutlined />
                      </>
                    )}
                  </PrimaryButtonV2>
                </SpaceBetween>
              </FormItem>
            </Form>
          )}
        </Spin>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep } = state.projects;
  return {
    project,
    loading,
    errors,
    currentStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

const QuestionsTitle = styled.div`
  /* Text lg/Regular */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: #535862;
  margin-bottom:12px;
`;
const QuestionsSubTitle = styled.div`
  /* Text md/Semibold */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #3f621a;
  margin-bottom:32px;
`;

const QuestionsInfo = styled.div`

  /* Text sm/Medium */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  color: #414651;
  margin-bottom:12px;
  clear: both;
`;

const QuestionsMainTitle = styled.div`
  margin-bottom:12px;
  /* Display sm/Semibold */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  /* identical to box height, or 127% */

  color: #181d27;
  
`;
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDescription);
